import { Controller } from "@hotwired/stimulus"
// @ts-ignore
import Sortable from "sortablejs"
import { patch } from "@rails/request.js"

export default class extends Controller {
  private sortable: any;

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      draggable: "[data-sortable-item]",
      ghostClass: "opacity-40",
      filter: ".sortable-ignore",
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onEnd(event: any) {
    const { newIndex, item } = event
    const url = item.dataset.sortableUrl

    if (!url) return

    const formData = new FormData()
    formData.append("position", (newIndex + 1).toString())

    await patch(url, {
      body: formData,
      responseKind: "json"
    })
  }
}
